import { Component, OnInit, ViewChild, Input, ViewContainerRef, Output, EventEmitter, ViewChildren, QueryList } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ItineraryService } from "../../itinerary.service";
import { RoomConfigurationItem } from "../../../home/search-box/categories/hotels/roomConfigurationItem";
import { CookieService } from "ngx-cookie";
import { isValidOwener, fillOwnerMessage } from "../../../utils/Functions";
import { UserService } from "../../../pages/com.usblick.common/auth/user.service";
import { environment } from "environments/environment";
import { OwlOptions } from "ngx-owl-carousel-o";
import { HotelService } from "./hotel.service";
import { acomodationsFilter, AcomodationTypes, BoardTypes, CancellationTypes, createCancellationFilter, createMealsFilter } from "app/content-result/category-result/filters-model";
import { starsHotels } from "app/content-result/category-result/result/base-result/information/categories/hotel-result/hotel-result-funtions";
import { MatDialog } from "@angular/material";
import { MaterialModalConfirmComponent } from "app/shared/material-modal-confirm/material-modal-confirm.component";
import { RoomComponent } from "./room/room.component";


@Component({
  selector: "usb-modal-hotel",
  templateUrl: "./modal-hotel.component.html",
  styleUrls: ["./modal-hotel.component.scss"],
})
export class ModalHotelComponent implements OnInit {
  @Input() productQty: number;
  @Input() hotel: any;
  @Input() results: any;
  @Input() form: any;
  @Input() payloadUpdate?: any;
  @Input() itineraryItem?: any;
  @Input() origin?: any;
  @Input() arrayResults?: any;
  @Input() view_info: any;
  @Input() tabActive?: any;
  @Input() arrivalDate: any;
  @Input() departureDate:any;
  @Input() payload: any;
  @Input() clientSetting: any;
  @Input() currencies: any[];
  @Input() currencyAgency: any;
  @Input() paymentAgencyActive: any;
  @Input() quote: boolean = true;
  @Input() action: string = '';
  @Output() refModal = new EventEmitter<any>();
  @ViewChild("gmap") gmapElement: any;
  @ViewChildren(RoomComponent) roomComponents!: QueryList<RoomComponent>;

  max: number;
  rate:number = 0;
  ratereview = 4.5;
  isReadonly: boolean;
  x = 5;
  y = 2;
  select: any[] = [];
  totalQty = 0;
  single: any[];
  view: any[] = [200, 150];
  disableButton: boolean = true;
  controTabs: boolean = false;
  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  showXAxisLabel = false;
  xAxisLabel = ".";
  showYAxisLabel = true;
  yAxisLabel = "%";
  form_: any;
  nuevoObjeto = [];
  nuevoObjetoAux: any[] = [];
  amenitiesRoom:any = [];
  arrServicesExtras: any[] = [];
  otherService: any[] = [];
  currencySelected: string;
  backgroundSelect: any;
  loadingToast: any;
  coordinatesArr: any[] = [];

  colorScheme = {
    domain: ["#00a680", "#00a680", "#00a680", "#00a680", "#00a680"],
  };

  tab: string = "";
  imgList: any[] = [];
  imgSelect: number = 0;
  _cookieClient: any = undefined;
  step = 0;
  roomsGroup = {};
  roomAdd: any;
  amenitiesHotelInfo = [];
  RoomsValueObs:number = 0;
  lastItemHotel:any[] = [];
  arrHowToGet:any[] = [];
  arrRequirements:any[] = [];
  arrRequirementsCovid:any[] = [];
  arrRequirementsOther:any[] = [];
  arrFacilitiesAndService: any[] = [];
  arrOthersTax: any[] = [];
  arrAccessibility:any[] = [];
  arrFoodAndDrink:any[] = [];
  amenitiesBoolean:boolean = true;
  howToGetBoolean:boolean = true;
  atracttionsBoolean:boolean = true;
  frequentsQBoolean:boolean = true;
  starRate:boolean = true;
  descriptText:string = '';
  descriptComplete:boolean = true;
  toggleDescript:string = '';
  booleanModal:boolean = true;
  continueProgress:boolean = false;
  selectedRooms: any[] = [];
  roomData: any[] = [];
  roomsArr: any[] = [];
  indexRoom: any[] = [];
  roomSelect = [];
  formAuxArr: any[] = [];
  formData: any;
  coverHotels:any[] =[];


  checkIn:string = '';
  checkOut:string = '';
  infoHotel: any[] = [];
  columnsInfoHotel: any[][] = [];
  buttonColorActive: string = '';
  buttonTextActive: string = '';

  mealsFilter: any[] = [];
  acomodationFilter: any[] = [];
  cancellationFilter: any[] = [];
  mealsFiltersArr: any[] = [];
  acomodationFiltersArr: any[] = [];
  cancellationFiltersArr: any[] = [];
  selectedBoardKeys: string[] = [];
  selectedAcomodationFilter: string[] = [];
  selectedTypeCancellation: string[] = [];

  selectedOptionIndex: boolean[] = [];
  selectedOptionIndexCancellationFilter: boolean[] = [];
  selectedOptionIndexAcomodationFilter: boolean[] = [];

  originalRooms: any[] = [];

  customOptionsPhotos: OwlOptions = {
    autoHeight: true,
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    navText: ['<img src="../../../../assets/img/app/arrow-izq-slider.png" />', '<img src="../../../../assets/img/app/arrow-der-slider.png" />'],
    items: 1,
    nav: true
    }


  starArray: number[] = [1, 2, 3, 4, 5];


  constructor(
    public vcr: ViewContainerRef,
    private _itineraryService: ItineraryService,
    private _cookieService: CookieService,
    public userService: UserService,
    private toastr: ToastrService,
    private hotelService: HotelService,
    public dialog: MatDialog
  ) {
    this.single = [
      {
        name: "Excelente",
        value: 74,
      },
      {
        name: "Muy Bueno",
        value: 19,
      },
      {
        name: "Regular",
        value: 6,
      },
      {
        name: "Malo",
        value: 1,
      },
      {
        name: "Pésimo",
        value: 0,
      },
    ];
    this._itineraryService.booleanModalActive$.subscribe((res:any) =>{
      this.booleanModal = res;


    })
  }

  ngOnInit() {

    if(!this.quote) {
      this.hotel.additionalInfo = this.hotel.hotelAdditionalInfo[0];
      this.hotel.coordinates = {
        latitude: this.hotel.additionalInfo.howtoget?.lat,
        longitude: this.hotel.additionalInfo.howtoget?.long
      };
      this.payload = this.hotel.payloadOriginal.products[0];
    } else {
      this.originalRooms = [...this.hotel.additionalInfo.rooms];
      this.mealsFilter = createMealsFilter([this.hotel]);
      this.mealsFiltersArr = this.mealsFilters();
      this.cancellationFilter = createCancellationFilter([this.hotel]);
      this.cancellationFiltersArr = this.cancellationFilters();
      // this.hotel.additionalInfo.rooms.forEach((room: any) => {
      //   room.room.roomBeds = [
      //     {
      //     bedType:'King'
      //     },
      //     {
      //     bedType:'Queen'
      //     }
      // ];
      // });
        this.acomodationFilter = acomodationsFilter([this.hotel]);
        this.acomodationFiltersArr = this.getAccomodationFilters();

    }
    const bookingFlow_sidebar = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_sidebar);
    this.backgroundSelect = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_body).card_background_price;
    this.buttonColorActive = bookingFlow_sidebar?.background_color_header;
    this.buttonTextActive = bookingFlow_sidebar?.color;
    // this.rate = Number(this.hotel.additionalInfo.starRating);
   this.rate = this.getStarsHotels(this.hotel.additionalInfo.starRating);

    const howtogets = this.hotel.additionalInfo.howtoget;
    this.arrHowToGet.push(howtogets);


    this.descriptText = this.hotel.description;


    this.checkIn = this.hotel.additionalInfo.TimeInformation.checkIn;
    this.checkOut = this.hotel.additionalInfo.TimeInformation.checkOut;

    this.formData = JSON.parse(localStorage.getItem("form"));

    if(!this.quote) {
      this.formData = this.hotel.form;
    }

    if(this.formData && Array.isArray(this.formData.room)) {
      const hotelRoomsState = JSON.parse(localStorage.getItem("hotel_rooms_state")).remainingConfigs;
      if(hotelRoomsState && hotelRoomsState.length > 0) {
        this.roomData = hotelRoomsState;
      }
    } else {
      this.roomData.push(this.formData.room);
    }


    this.tab = this.tabActive ? this.tabActive : "rooms";

    if (!this.view_info) {
      if (this.hotel !== undefined && this.hotel.additionalInfo !== undefined) {
        if (this.hotel.additionalInfo.rooms !== undefined) {
          this.createSelectsOfRoom(this.hotel.additionalInfo.rooms.length, this.productQty + 1);
        }
        if (this.hotel.additionalInfo.roomsPackage !== undefined) {
          this.createSelectsOfRoom(this.hotel.additionalInfo.roomsPackage.length, this.productQty + 1);
        }
      }
    }
    this.setRoomsGroup();
    // this.loadImages();
    this.getAmenitiesHotelInfo();
    this.getRequirements();
    this.getObservations();
    this.servicesExtras();
    this.booleanGenerals();
    this.toggleDescript = 'Ver Más';
    this.toggleTextComplete();
    this.getInfoHotel();
    this.getAmenitiesRoom();
    this.coverHotelsInfo();
    this.generateCoordinates();
    // this.formatCheckTimes();
  }

  generateCoordinates(): void {
      this.coordinatesArr = [{
              coordinates:  {longitude: Number(this.hotel?.coordinates?.longitude), latitude: Number(this.hotel?.coordinates?.latitude)},
              hotel_name: this.hotel.title,
              address: this.hotel.additionalInfo?.location,
              cancellationPolicies: this.hotel.additionalInfo?.rooms[0]?.room?.cancellationPolicy,
              priceUnitary: this.hotel.additionalInfo?.rooms[0]?.room?.netPriceProf,
              price: this.hotel.additionalInfo?.rooms[0]?.room?.optionNightsNetTotalProf,
              boardName: this.hotel.additionalInfo?.rooms[0]?.room?.boardName,
              images: this.hotel.additionalInfo?.images,
              rateClass: this.hotel.additionalInfo?.rooms[0]?.room?.rateClass,
              views: this.hotel.view_hotel,
              id: this.hotel.id,
              starRating: Number.parseInt(this.hotel.additionalInfo.starRating),
              currency: this.hotel.additionalInfo?.rooms[0]?.room?.pricing?.currency,
              generalMap: false,
              origin: this.origin
            }];
  }

  selectionChange(rooms: any) {
    //Tuve que cambiar la forma en como accedía, generaba un bug en el select.
    // this.roomData = rooms?.room;
    this.roomData = rooms;
  }

  pushRoomSearch(room: any) {
    this.roomData.push(room);
  }

  getAmenitiesHotelInfo() {
    this.amenitiesHotelInfo = this.hotel?.additionalInfo?.amenities
      .filter(function (amenite: any) {
        return amenite.amenity_type === "hotel";
      })
      .map(function (amenite: any) {
        return amenite;
      });


  }

  getAmenitiesRoom(){
    this.amenitiesRoom = this.hotel.additionalInfo.amenities.filter(
      (amenitie:any) => {
        return amenitie.amenity_type === "room";
      }
    )
  }



  setRoomsGroup() {
    let i = 0;

    const roomType = this.hotel.additionalInfo?.rooms;


    this.currencySelected = roomType[0]?.room?.pricing?.currency;
    this.nuevoObjeto = roomType.reduce(function (r, a) {
      r[a.room.roomType] = r[a.room.roomType] || [];
      r[a.room.roomType].push(a);
      return r;
    }, Object.create(null));



    Object.keys(this.nuevoObjeto).map((key) => {
      this.nuevoObjetoAux[i] = this.nuevoObjeto[key];
      i++;
    });
  }

  setStep(index: number) {
    this.step = index;
  }

  cacheReturn() {
    if (localStorage.getItem("others")) {

      return JSON.parse(localStorage.getItem("others"));
    } else {
      // tslint:disable-next-line:max-line-length
      return this.arrayResults === undefined
        ? this.itineraryItem.payloadUpdate.products[0].others !== undefined
          ? this.itineraryItem.payloadUpdate.products[0].others
          : ""
        : this.arrayResults.others;
    }
  }

  cacheAdd() {
    if (this.itineraryItem) {
      // tslint:disable-next-line:max-line-length
      // console.log(
      //   "this.itineraryItem.payloadUpdate.products[0].others",
      //   this.itineraryItem.payloadUpdate ? this.itineraryItem.payloadUpdate.products[0].others : "no existe"
      // );
    }

    if (this.itineraryItem) {
      if (!localStorage.getItem("others")) {

        localStorage.setItem("others", JSON.stringify(this.itineraryItem.payloadUpdate.products[0].others));
      }
    }
  }

  mapMarker() {
    //se inicializa el mapa con zoom 4
    // var geocoder;
    // var mapa;
    // var mapOptions = {
    //   center: new google.maps.LatLng(28.3256749, -81.51555309999999),
    //   zoom: 4,
    //   mapTypeId: google.maps.MapTypeId.ROADMAP,
    // };

    // //seteamos el maa
    // mapa = new google.maps.Map(this.gmapElement.nativeElement, mapOptions);

    // //buscamos las coordenadas con la direccion dada del hotel
    // geocoder = new google.maps.Geocoder();
    // var title = this.hotel.title;
    // geocoder.geocode({ address: this.hotel.additionalInfo.location.trim() }, (results, status) => {
    //   if (status.toString() == "OK") {
    //     var marker = new google.maps.Marker({
    //       map: mapa,
    //       position: results[0].geometry.location,
    //       title: title,
    //     });

    //     google.maps.event.trigger(mapa, "resize");
    //     //colocamos el market
    //     mapa.panTo(marker.getPosition());
    //     mapa.setZoom(16);
    //   } else {
    //     // console.log("No se obtuvo la ubicacion del mapa: " + status);
    //   }
    // });
    // mapa.set("parent", this);
  }

  /**
   * Metodo que crea los select que se veran reflejados en las habitaciones.
   * @param qty Indica la cantidad de select que se crearan (se crea 1 por cada room del hotel).
   * @param maxProductSelect Indica los valores del array (se le agrega 1 mas por el valor 0).
   */
  createSelectsOfRoom(qty: number, maxProductSelect: number) {
    for (let i = 0; i < qty; i++) {
      this.select.push({
        selectArray: Array.from(Array(maxProductSelect).keys()),
        selectValue: 0,
      });
    }
  }

  calculateTotalPrice(room: any) {
    this.totalQty = 0;
    this.disableButton = true;

    if (room == 0) {
      // Manejar el caso de que room sea 0 si es necesario
    } else {
      // Verificar si una habitación con el mismo roomCode ya está en la lista

      const existingRoomIndex = this.selectedRooms.findIndex(selectedRoom => selectedRoom.room.roomCode === room?.room?.roomCode);

      if (existingRoomIndex !== -1) {
        // Si la habitación ya está en la lista, agrega una nueva entrada en el array de habitaciones seleccionadas

        const addons = room?.room?.netPriceBookingAddons ? room?.room?.netPriceBookingAddons : 0;

        const newRoom = {
          ...room,
          productKey: this.getRandom()
        };
        this.selectedRooms.push({
          room: newRoom,
          total: room?.room?.optionNightsNetTotalProf + addons
        });

      } else {

        const addons = room?.room?.netPriceBookingAddons ? room?.room?.netPriceBookingAddons : 0;

        // Si la habitación no está en la lista, agrega una nueva entrada en el array de habitaciones seleccionadas
        const newRoom = {
          ...room,
          productKey: this.getRandom()
        };
        this.selectedRooms.push({
          room: newRoom,
          total: room?.room?.optionNightsNetTotalProf + addons
        });

      }
      // Calcula el total general sumando los totales de todas las habitaciones seleccionadas
      this.totalQty = this.selectedRooms.reduce((total, selectedRoom) => total + selectedRoom.total, 0);



      this.disableButton = false;
    }
  }

calculateTotalPriceWithout(room: any) {
  const roomNetPrice = room.roomSelect.optionNightsNetTotalProf + room.roomSelect.netPriceBookingAddons;

  this.totalQty -= roomNetPrice;

  // Encuentra el índice del objeto en el array this.selectedRooms
  const indexToRemove = room.selectedIndex;

  // Si el índice está dentro del rango del array, elimina el elemento correspondiente
  if (indexToRemove >= 0 && indexToRemove < this.selectedRooms.length) {
    this.selectedRooms.splice(indexToRemove, 1);
  }


  if(this.selectedRooms.length === 0) {
    this.disableButton = true;
  }
}

  modalRomms() {
    this.max = 10;
    this.isReadonly = true;
  }
  modalRoom() {
    this.isReadonly = true;
  }

  continue() {
    const validation = this.verifyAddonsIsMandatory();

    if(validation.isValid) {
            this.loadingToast = this.toastr.info('Procesando producto...', 'Cargando', {
                                disableTimeOut: true,
                                tapToDismiss: false
                              });
            for (let index = 0; index < this.selectedRooms.length; index++) {
                this.addItinerary(this.selectedRooms[index].room, this.hotel, index);
                this.hotelService.addSelectedRoom(this.selectedRooms[index].room);
            }
              this._itineraryService.itinerary.totalTaxPrice = this.totalTax();
              this._itineraryService.itinerary.clientId = this.clientSetting?.id;
              this._itineraryService.itinerary.nights = this._itineraryService.itinerary?.destination[0]?.destination_info.nights;
              this._itineraryService.itinerary.arrivalDate = this._itineraryService.itinerary?.items[0].arrivalDate;
              this._itineraryService.itinerary.departureDate = this._itineraryService.itinerary?.items[0].departureDate;
              this._itineraryService.itinerary.currency = this.currencySelected;

              //actualizar el itinerario
               this.toastr.remove(this.loadingToast.toastId);

              this._itineraryService.updateItinerary(this._itineraryService.itinerary);
              this.selectedRooms = [];
    } else {
      // Mostrar mensaje con los tipos faltantes
      const typesText = validation.missingTypes.join(', ');
      this.toastr.warning(`Es obligatorio seleccionar: ${typesText}`);
    }

  }

  /**
 * Verifica si todos los adicionales obligatorios están seleccionados
 * @returns Objeto con estado y lista de tipos faltantes
 */
verifyAddonsIsMandatory(): { isValid: boolean; missingTypes: string[] } {
  const missingTypesSet = new Set<string>();

  for (const room of this.selectedRooms) {
    const availableExtras = room?.room?.room?.extras || [];
    const selectedAddons = room?.room?.room?.addonsIncluded || [];

    if(availableExtras && Array.isArray(availableExtras)) {
        for (const extra of availableExtras) {
        if (!extra.ismandatory) continue;

        let hasSelected = false;

        if (extra.options && extra.options.length > 0) {
          hasSelected = selectedAddons.some((addon: any) =>
            extra.options.some((option: any) => option.optionId === addon.optionId)
          );
        } else {
          hasSelected = selectedAddons.length > 0;
        }

        if (!hasSelected) {
          // Guardar el tipo del extra que falta (ej: 'Transfer', 'Attractions', etc.)
          missingTypesSet.add(this.getType(extra.type) || extra.title || 'adicional');
        }
      }
    }

  }

  const missingTypes = Array.from(missingTypesSet);

  return {
    isValid: missingTypes.length === 0,
    missingTypes
  };
}

getType(type: string): string {
  let typeStr: string = ''

  switch(type) {
    case 'Transfer': typeStr = 'traslado';break;
    case 'Attractions': typeStr = 'atraccion';break;
    case 'Hotel Supplements': typeStr = 'sugerencia';break;
  }


  return typeStr;
}




// verifyAddonsIsMandatory(): boolean {

//   const allRoomsValid = this.selectedRooms.every((room: any, roomIndex: number) => {

//     if (!room?.room?.room?.extras || room?.room?.room?.extras.length === 0) {
//       return true;
//     }


//     const allExtrasValid = room.room.room.extras.every((extra: any, extraIndex: number) => {

//       if (!extra.ismandatory) {
//         return true;
//       }

//       // Si el extra tiene Options, verificar que se seleccionó alguna opción
//       if (extra.options && extra.options.length > 0) {
//         const hasSelectedOption = room?.room?.room?.addonsIncluded?.some((addon: any) => {
//           // Verificar si el addon incluido corresponde a alguna opción de este extra
//           const optionExists = extra.options.some((option: any) =>
//             option.optionId === addon.optionId
//           );
//           return optionExists;
//         });

//         return hasSelectedOption;
//       } else {
//         // Si no tiene Options, verificar que haya algún addon incluido
//         const hasAnyAddon = room?.room?.room?.addonsIncluded?.length > 0;
//         return hasAnyAddon;
//       }
//     });

//     return allExtrasValid;
//   });

//   return allRoomsValid;
// }

  totalTax(){
    let taxSum: number = 0;
    const itemTax: any[] = [];
    const items: any[] = this._itineraryService.itinerary?.items || [];


    items.forEach(item => {
      if(item.taxes && item.taxes.length > 0) {

        item.taxes.forEach(tax => {
          itemTax.push(tax);
        })
      }
    })

    itemTax.forEach(tax => {
      if(typeof tax.included === 'boolean' && tax.included && typeof tax.amount === 'number') {
        taxSum += tax.amount;
      }
    });

    return parseFloat(taxSum.toFixed(2));

  }



  productQtyNowSelect(select: any[]): number {
    let total = 0;
    select.forEach((obj) => (total += +obj.selectValue));
    return total;
  }

  close() {
    this._emitRefModal("close");
  }

  selectedIndexRoom(index: any) {
    this.indexRoom.push(index)

  }

  addItinerary(item: any, hotel: any, roomIndex?: number) {
    // validar si owner esta lleno
      if (!isValidOwener(this._cookieService.get("clientActive"))) {
        this._emitRefModal("warning - Warning - " + fillOwnerMessage());
        return;
      }


      const adittionalInfo = [...hotel.additionalInfo];
      // Guardar el ID original del producto antes de transformarlo
      const itemId = hotel.id;
      // hotel.additionalInfo.rooms = []; //lo tuve que comentar dado que no renderizaba los precios en el category-results.

      if(item.room.netPriceBookingAddons && item.room.netPriceBookingAddons > 0) {
        item.room.profility = this.getProfilityAddons(item);

        item.room.optionNightsNetTotalProf = item?.room?.optionNightsNetTotalProf + item?.room?.netPriceBookingAddons;
        item.room.netPriceProf = item?.room?.netPriceProf + item?.room?.netPriceBookingAddons;
        item.room.optionNightsNetTotalFreeTax = item?.room?.optionNightsNetTotalFreeTax + item?.room?.netPriceBookingAddons;
        item.room.netPriceFreeTax = item?.room?.netPriceFreeTax + item?.room?.netPriceBookingAddons;
      }

      // Asignar el ID original a octopus_id (campo permanente)
      item.octopus_id = itemId;
      item.adults = item.adults;
      item.childrens = item.childrens;
      item.optionNightsNetTotalProf = item?.room?.optionNightsNetTotalProf ? item?.room?.optionNightsNetTotalProf : 0;
      item.taxes = item?.room?.pricing?.taxes ? item?.room?.pricing?.taxes : [];
      item.netPriceProf = item?.room?.netPriceProf ? item?.room?.netPriceProf : null;
      item.optionNightsNetTotalFreeTax = item?.room?.optionNightsNetTotalFreeTax ? item?.room?.optionNightsNetTotalFreeTax : 0; // suma total de las noches sin impuestos
      item.netPriceFreeTax = item.room?.netPriceFreeTax ? item.room?.netPriceFreeTax : 0; // tarifa por noche sin impuesto
      item.taxPrice = 0; //monto impuesto por noche
      item.taxNightsPriceTotal = this.dataTax(item?.room?.pricing?.taxes); // suma total impuestos de las noches
      item.tax = 0; // valor del iva aplicado
      item.profility = item?.room?.profility ? item?.room?.profility : 'Falta profility';
      // Sobrescribir el ID con el roomId para uso local
      item.id = item?.room?.roomId;
      item.searchId = hotel?.searchId;
      item.providerId = item?.provider?.id;
      item.providerName = item?.provider?.name;
      item.nameAdapter = hotel?.nameAdapter;
      item.hotelId = item?.hotelCode;
      item.idProduct = item?.room?.hotelCode;
      item.categoryName = "HOTELS";
      item.title = hotel?.title;
      item.location = hotel?.additionalInfo?.location;
      item.arrivalDate = hotel?.dateIni;
      item.departureDate = hotel?.dateEnd;
      item.updateDate = new Date();
      item.categoryHotel = adittionalInfo[0].starRating;
      item.cancellation_policy = item?.room?.cancellationPolicy || [];
      item.expiration_date = item?.room?.cancellationPolicy && item?.room?.cancellationPolicy.length > 0 && item?.room?.cancellationPolicy[0].amount > 0 ? this.adjustDate(item?.room?.cancellationPolicy[0].from, -1) : null;
      item.bookParam = item?.room?.bookParam;
      item.amount = hotel.amount;
      item.imagen = hotel.additionalInfo.images[0]?.image;
      item.hotelAdditionalInfo = adittionalInfo;
      item.hotelAdditionalInfo.coordinates = hotel.coordinates;
      item.description = hotel?.description;
      item.roomType = item?.room?.roomType;
      item.boardName = item?.room?.boardName;
      item.rateClassId = item?.room?.rateClass ? item?.room?.rateClass : null;
      item.boardNameCode = item?.room?.boardName ? item?.room?.boardName : null;
      item.roomId = item?.room?.roomId ? item?.room?.roomId : null;
      item.roomCode =  item?.room?.roomCode ? item?.room?.roomCode : null;
      item.currency = item?.room?.pricing?.currency ? item?.room?.pricing?.currency : null;
      item.nights = item.stay.nights;
      item.flightMandatory = item.room.extras && item.room.extras.length > 0 ? item.room.extras.some(c => c.requiresflightdetails === true) : false;
      item.serviceExtra = this.getServiceExtra(item);
      item.hotelAdditionalInfo.rooms = [];
      item.hotelAdditionalInfo[0].rooms = [];
      item.hotelAdditionalInfo.roomInfo = [];
      item.hotelAdditionalInfo[0].roomInfo = [];
      item.checkTimes = this.hotel?.additionalInfo?.TimeInformation;
      // item.hotelAdditionalInfo.country = 'BR';


      // se agrega el payload de busqueda de producto al objeto rentacar
      this.form = JSON.parse(localStorage.getItem("form"));
      if (!this.form || !this.form.room || !Array.isArray(this.form.room)) {
        this.form = JSON.parse(localStorage.getItem("form"));
        this.formAuxArr.push(this.form.room);
        this.form.room = this.formAuxArr;
      }
      let roomIndexProduct
      if(this.selectedRooms.length <= 1) {
        for( let i = 0; i < this.selectedRooms.length; i++) {
          roomIndexProduct = this.form.room[this.indexRoom[i]];
        }
      } else {
        roomIndexProduct = this.form.room[roomIndex];
      }

      // Obtén el valor de roomDescriptionIndex
      const roomDescriptionIndex = roomIndexProduct
      // Asegúrate de que 'this.form' y 'this.form.room' sean objetos válidos

      for (let i = 0; i < this.selectedRooms.length; i++) {
        let uniqueProductKey = this.getRandom();
        while (this.selectedRooms.some(room => room.room.productKey === uniqueProductKey)) {
          uniqueProductKey = this.getRandom();
        }
        this.selectedRooms[i].room.productKey = uniqueProductKey;
      }


      // Actualiza 'room' en el formulario
      this.form.room = roomDescriptionIndex;
      item.form = this.form;
      item.payloadUpdate = this._payloadUpdateHotel(this.form, item); // ( this.form.value
      item.payloadOriginal = this._getPayloadOriginalInfo(this.form, item);
      item.destination = this._itineraryService.getDestinationInfo(this.form, item);

    if (this.itineraryItem) {
      item.destination = this.itineraryItem.destination;
      this._itineraryService.remove(this.itineraryItem, item);
      this.toastr.success("Congratulations !!", "Product Successfully updated");
    } else {

      this._itineraryService.sendMessageSubscriptorLoading(true);
      this._itineraryService.add(item).subscribe(
        (response: any) => {

          if (typeof response === "string") {
            this._emitRefModal("error - Error - " + response);
          } else {

            this._itineraryService.currencySuccessEmit.next(item.currency);
            this._emitRefModal("productAdd");
            this.toastr.success("¡Felicitaciones! Producto agregado con éxito. ");
          }
          this._itineraryService.evaluateDateItineraryRange(this._itineraryService.itinerary["items"]);
        },
        (error) => {

          this._emitRefModal("error - Error - Item was not added to your itinerary");
          this._itineraryService.sendMessageSubscriptorLoading(false);
        }
      );
    }
    this._itineraryService.lastItemHotel$.next(item);
  }

  getRandom(): number {
    return Math.floor(Math.random() * 20000000000000) + Date.now();
  }

  adjustDate(date: string | Date, days: number): string {
  if (!date) return '';

  // Convertir Date a string si es necesario
  let dateStr: string;
  if (typeof date === 'string') {
    dateStr = date;
  } else {
    // Asumiendo que es un objeto Date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    dateStr = `${year}-${month}-${day}`;
  }

  const d = new Date(dateStr);
  d.setDate(d.getDate() + days);
  return d.toISOString().split('T')[0];
}


  private getServiceExtra(item: any): any[] {
    const arr: any[] = [];
    if (item.room.addonsIncluded && item.room.addonsIncluded.length) {
      item.room.addonsIncluded.forEach((addon: any) => {
        arr.push({ name: addon.title, price: addon.netcost.amount });
      });
    }
    return arr;
  }


  private getProfilityAddons(item: any): any {
    return {
          netPrice: item?.room?.profility?.netPrice + item?.room?.netPriceBookingAddons,
          netPriceBooking: item?.room?.profility?.netPriceBooking + item?.room?.netPriceBookingAddons,
          netPriceCategory: item?.room?.profility?.netPriceCategory + item?.room?.netPriceBookingAddons,
          netPriceProvider: item?.room?.profility?.netPriceProvider + item?.room?.netPriceBookingAddons,
          percentage: item?.room?.profility?.percentage,
          percentageBooking: item?.room?.profility?.percentageBooking,
          percentageCategory: item?.room?.profility?.percentageCategory,
          percentageProvider: item?.room?.profility?.percentageProvider,
          blickoins: item?.room?.profility?.blickoins,
          creditBlickoins: item?.room?.profility?.creditBlickoins
        };
  }

  getOthers() {
    const others = {
      maxRequestTimeOnSeconds: 20,
      minNumResults: 3,
      roomConfiguration:
        // tslint:disable-next-line:max-line-length
        this.payloadUpdate.others !== undefined ? this.payloadUpdate.others.roomConfiguration : this.payloadUpdate.products[0].others,
    };

    return others;
  }

  _getPayloadOriginalInfo(form: any, item: any): Object {
    let others;
    let payload;

    const pax = JSON.parse(localStorage.getItem("payload"));
    const formOriginal = JSON.parse(localStorage.getItem("form"));
    const formLength = formOriginal.room.length;

    if (this.origin === undefined || this.origin == "HOTELS") {

      this._getRoomDistOriginal(form,item);
      if(this.selectedRooms.length < formLength) {
        const dist = this.roomDist.filter((_, index) => index < formLength);
        this.roomDist = dist;
      }
      others = {
        agedriver: environment.agedriver,
        serialized: environment.serialized,
        maxRequestTimeOnSeconds: environment.maxRequestTimeOnSeconds,
        minNumResults: environment.minNumResults,
        maxNumResultsPerAdapter: environment.maxNumResultsPerAdapter,
        hotels: {
          roomConfiguration: this.roomDist,
        },
      };
    }

    payload = {
      products: [
        {
          providerId: item.providerId,
          nameAdapter: item.nameAdapter,
          categoriesId: [1], // Hotel
          productId: item.room.hotelCode,  //this.hotel.id,//
          productName: item.title,
          origin: this.hotel.origin,
          destination: this.hotel.destination,
          city: " ", //form.destination.cityName,
          priceFrom: 0,
          priceTo: 0,
          arrivalDate: item.arrivalDate,
          departureDate: item.departureDate,
          qtyProduct: 1,
          qtyPax: pax[0].qtyPax,
          others: others,
          agencyId: pax[0].agencyId,
          nationality: form.nationality
        },
      ],
    };

    return payload;

  }

  roomDist = [];

  _getRoomDistOriginal(form: any, item: any) {
      let roomsArr = [];
      const rooms = form.room;
      const formOriginal = JSON.parse(localStorage.getItem("form"));
      const formLength = formOriginal.room.length;
      roomsArr.push(rooms)

      if(this.selectedRooms.length < formLength) {

        for (let i = 0; i < roomsArr.length; i++) {
          this._roomsOriginal(form,item, formLength);
        }

      } else if (this.selectedRooms.length == formLength) {
        for (let i = 0; i < roomsArr.length; i++) {

          const people = [];
          const dist: RoomConfigurationItem = {
            adults: 0,
            children: [],
            boardNameCode: item.boardNameCode,
            condition: item.rateClassId,
            roomId:item.roomId,
            roomCode:item.roomCode,
            bookingCode: item.bookParam,
            extras: this.getExtraServicePayloadUpdate(item)
          };
          const adults = rooms.qtyAdults;
          const children = rooms.childsage;
          for (let j = 0; j < children.length; j++) {
            people.push(children[j].age);
          }
          dist.adults = adults;
          dist.children = people;

          this.roomDist.push(dist);

      }

      return this.roomDist;
      }

  }

  _roomsOriginal(form: any, item: any, formLength: any) {
    const rooms = form.room;
    const roomsArr = [];

    // Agregar elementos a roomsArr
    for(let i = 0; i < this.selectedRooms.length; i++) {
      roomsArr.push(this.selectedRooms[i].room);
    }

    for (let i = roomsArr.length; i < formLength; i++) {
      const newItem = { ...item }; // Clonar el elemento inicial en cada iteración
      newItem.boardNameCode = -1;
      newItem.condition = -1;
      newItem.roomId = -1;
      newItem.roomCode = -1;
      newItem.bookingCode = -1;
      roomsArr.push(newItem); // Agregar el clon al array
    }

    for (let i = 0; i < roomsArr.length; i++) {

      const people = [];
      const dist: RoomConfigurationItem = {
        adults: 0,
        children: [],
        boardNameCode: roomsArr[i].boardNameCode,
        condition: roomsArr[i].rateClassId,
        roomId: roomsArr[i].roomId,
        roomCode: roomsArr[i].roomCode,
        bookingCode: roomsArr[i].bookParam,
        extras: this.getExtraServicePayloadUpdate(item)
      }
      const adults = rooms.qtyAdults;
      const children = rooms.childsage;
      for (let j = 0; j < children.length; j++) {
        people.push(children[j].age);
      }
      dist.adults = adults;
      dist.children = people;
      this.roomDist.push(dist);

    }
    return this.roomDist;
  }



    private dataTax(data: any): number {
    let taxSum: number = 0;
    if (data && data.length > 0) {
      data.forEach((tax) => {
              // Verifica si 'included' es un booleano verdadero
              if (typeof tax.included === 'boolean' && tax.included) {
                // Si 'included' es true, suma el impuesto al total
                taxSum += tax.amount;
              }
            });
          }

          return taxSum;
  }

  _payloadUpdateHotel(form: any, item: any): Object {

    let payloadSearch = JSON.parse(localStorage.getItem('payload'));

    let qtyPax;
    let others;
    let payload;

    if (this.origin === undefined || this.origin == "HOTELS") {
      others = {
        agedriver: environment.agedriver,
        serialized: environment.serialized,
        maxRequestTimeOnSeconds: environment.maxRequestTimeOnSeconds,
        minNumResults: environment.minNumResults,
        maxNumResultsPerAdapter: environment.maxNumResultsPerAdapter,
        hotels: {
          roomConfiguration: this._getRoomDist(form,item),
        },
      };
    }

    payload = {
      products: [
        {
          providerId: item.providerId,
          nameAdapter: item.nameAdapter,
          categoriesId: [1], // Hotel
          productId: item.room.hotelCode,  // this.hotel.id
          productName: item.title,
          origin: this.hotel.origin,
          destination: this.hotel.destination,
          city: " ", //form.destination.cityName,
          priceFrom: 0,
          priceTo: 0,
          arrivalDate: item.arrivalDate,
          departureDate: item.departureDate,
          qtyProduct: 1,
          qtyPax: item.room?.availability.maxPax,
          others: others,
          agencyId: payloadSearch[0].agencyId,
          nationality: form.nationality,
          country: payloadSearch[0].country, //Para el hacer el research, se necesita el country.
        },
      ],
    };

    return payload;
  }

  _getRoomDist(form?: any, item?: any) {
    const roomDist = [];
    const rooms = form.room;
    let roomsArr = [];
    roomsArr.push(rooms)

    for (let i = 0; i < roomsArr.length; i++) {
      const dist: RoomConfigurationItem = {
        adults: item.adults,
        // children: item.childsAge,
         children: item.childsAge && item.childsAge.length > 0 ? item.childsAge.map(c => c.age) : [],
        boardNameCode: item.boardNameCode,
        condition: item.rateClassId,
        roomId:item.roomId,
        roomCode:item.roomCode,
        bookingCode: item.bookParam,
        extras: this.getExtraServicePayloadUpdate(item),
      };

      roomDist.push(dist);

  }
  return roomDist;
}

private getExtraServicePayloadUpdate(item): any[] {
  const arr: any[] = [];

  if(item.room.addonsIncluded && item.room.addonsIncluded.length > 0) {
    item.room.addonsIncluded.forEach((addon: any) => {
      // Buscar el extra que contiene esta opción
      const foundExtra = item.room.extras?.find((extra: any) => {
        return extra.options?.some((option: any) =>
          option.optionid === addon.optionid
        );
      });

      if (foundExtra) {
        arr.push({
          extraId: foundExtra.extraid,
          optionId: addon.optionid
        });
      } else {
        console.warn(`No se encontró el extra para la opción ${addon.optionid}`);
      }
    });
  }

  return arr;
}

  _emitRefModal(status: string) {
    this.refModal.emit(status);
  }


  // Pasar primer letra de cada palabra a mayuscula en una cadena
  stingUpperCase(str) {
    if (str) {
      let e = str.toLowerCase();
      return e.replace(/\b\w/g, (l) => l.toUpperCase());
    }
  }

  getRequirements(){
    this.hotel.additionalInfo.checkin_requirement.forEach((e:any) => {
      this.arrRequirements.push(e);

    });

    if(this.hotel.additionalInfo.covid_requirement){
      this.hotel.additionalInfo.covid_requirement.forEach((e:any) => {
        this.arrRequirementsCovid.push(e);

      });
    }

    if(this.hotel.additionalInfo.other_requirement){
      this.hotel.additionalInfo.other_requirement.forEach((e:any) => {
        this.arrRequirementsOther.push(e);
      });
    }

    if(this.hotel.additionalInfo.other_services_extra){
      this.hotel.additionalInfo.other_services_extra.forEach((e: any) => {
        this.otherService.push(e);
      })
    }

    if(this.quote) {
      if(this.hotel.additionalInfo.rooms[0].room.pricing.taxes) {
        this.arrOthersTax.push(this.hotel.additionalInfo?.rooms[0]?.room?.pricing.taxes[0]);
      }
    }



  }

  getObservations() {
    if(this.hotel.additionalInfo.amenities.length > 0) {


    this.hotel.additionalInfo.amenities.forEach((e:any) => {

      if (e.ame_subtype === 'Accesabilidad') {
        const nameObservation = 'Accesabilidad';

        // Añadir nameObservation solo si no está presente en facility
        const existingItem = this.arrFacilitiesAndService.find(item => item.facility === nameObservation);

        if (!existingItem) {
          this.arrFacilitiesAndService.push({ facility: nameObservation, services: [] });
        }
        // Añadir todos los elementos de e.name al array services
        const arrObservation = this.arrFacilitiesAndService.find(c => c.facility === nameObservation);
        arrObservation.services.push(e.name);
      }
      if(e.ame_subtype === 'Comida') {
        const nameObservation = 'Comida';
        // Añadir nameObservation solo si no está presente en facility
        const existingItem = this.arrFacilitiesAndService.find(item => item.facility === nameObservation);

        if (!existingItem) {
          this.arrFacilitiesAndService.push({ facility: nameObservation, services: [] });
        }
         // Añadir todos los elementos de e.name al array services
         const arrObservation = this.arrFacilitiesAndService.find(c => c.facility === nameObservation);
         arrObservation.services.push(e.name);
      }
    });

    }
  }

/**
 * Función servicesExtras: Extrae y transforma la información de servicios adicionales de un hotel.
 *
 * @description Esta función toma la información de servicios extras de un hotel y la transforma en un array de objetos con propiedades 'name' y 'value'.
 *               Luego, elimina los primeros dos elementos de dicho array.
 *               Finalmente, imprime el array resultante en la consola.
 *
 * @memberof NombreDelComponenteOClase
 * @method servicesExtras
 * @returns {void} No devuelve nada, solo imprime el resultado en la consola.
 */
servicesExtras(): void {
      // Objeto de mapeo para traducción de nombres de servicios
    const servicesTraductor = {
      accept_babies: 'aceptan bebés',
      baby_price_has_cost: 'tienen costo extra los bebes',
      accept_children: 'aceptan niños/as',
      children_price_has_cost: 'tienen costo extra los/as niños/as',
      baby_has_extra_bed: 'el bebé tiene cama extra',
      extra_bed_baby_has_cost: 'tiene costo extra la cama del bebé',
      accept_pets: 'aceptan mascotas',
      cleaning_service: 'servicio de limpieza',
      reservation_fee: 'cuota de reserva',
      city_tax: 'impuesto municipal',
      city_tax_has_cost: 'tiene costo el impuesto municipal',
      iva_tax: 'impuesto iva'
    };

  // Verifica si hay información de servicios extras en el hotel
  if(this.hotel.additionalInfo.services_extra){ //validación temporal porque services_extra no esta en la respuesta.
    if (this.hotel.additionalInfo.services_extra.length > 0) {
      // Transforma la información en un array de objetos con propiedades 'name' y 'value'
      const keyValueObjectsArray = this.hotel.additionalInfo.services_extra.reduce((accumulator: any[], currentObject: any) => {
        // Mapea las entradas del objeto a un array de objetos con propiedades 'name' y 'value'
        const pairs = Object.entries(currentObject).map(([name, value]) => ({ name: servicesTraductor[name] || name, value }));
        // Concatena los arrays de pares 'name'-'value' al acumulador
        return accumulator.concat(pairs);
      }, []).slice(2); // Elimina los primeros dos elementos del array resultante

      // Imprime el array resultante en la consola
      this.arrServicesExtras = keyValueObjectsArray;
    }
  }

}



  booleanGenerals():void{


    if(this.amenitiesHotelInfo.length == 0){
      this.amenitiesBoolean = false;
    }

    if(this.arrHowToGet.length == 0){
      this.howToGetBoolean = false;
    }

    if(this.hotel.additionalInfo.atracttions.length == 0){
      this.atracttionsBoolean = false;
    }

    if(!this.hotel.additionalInfo.frequentquestions){
      this.frequentsQBoolean = false;
    }

    if(this.hotel.additionalInfo.starRating === '0' || this.hotel.additionalInfo.starRating === null){
      this.starRate = false;
    }
  }

  toggleTextComplete(){
    this.descriptComplete = !this.descriptComplete;
    if(this.descriptComplete){
      this.toggleDescript = 'Ver Menos';
    }else{
      this.toggleDescript = 'Ver Más';
    }
  }

  verifyConditionInfo(hotelInfo: any): boolean {
    return Number(hotelInfo) > 0;
  }

  /**
   * @description Este metodo filtra por las imagenes que sea portadas establecidas por los proveedores, validando
   * con la propiedad is_cover.
   */
  coverHotelsInfo():void{
    const coversImage = this.hotel.additionalInfo.images.filter((images:any) => images.is_cover == 1);


    if(coversImage.length > 0){
      this.coverHotels = coversImage;
    }

  }



  getInfoHotel(): void {
    this.infoHotel.push(
      {
        title: 'Tipo',
        image: '/assets/img/app/modal/hotel.svg',
        value: 'Hotel',
      },
      {
        title: 'Categoría',
        image: '',
        value: this.hotel?.additionalInfo?.starRating ?? 'N/A',
      },
            {
        title: 'Pisos',
        image: '/assets/img/app/modal/edificio.svg',
        value: this.hotel?.additionalInfo?.numberOfFloors && this.hotel?.additionalInfo?.numberOfFloors > 0 ? this.hotel?.additionalInfo?.numberOfFloors : 'N/A',
      },
      {
        title: 'Habitaciones',
        image: '/assets/img/app/modal/cama.svg',
        value: this.hotel?.additionalInfo?.numberOfrooms && this.hotel?.additionalInfo?.numberOfrooms > 0 ? this.hotel?.additionalInfo?.numberOfrooms : 'N/A',
      },
            {
        title: 'Años',
        image: '/assets/img/app/modal/calendar.svg',
        value: this.hotel?.additionalInfo?.constructionYear && this.hotel?.additionalInfo?.constructionYear > 0 ? this.hotel?.additionalInfo?.constructionYear   : 'N/A',
      },
      {
        title: 'Restaurante',
        image: '/assets/img/app/modal/resto.svg',
        value: this.hotel?.additionalInfo?.numberOfRestaurants && this.hotel?.additionalInfo?.numberOfRestaurants > 0 ? this.hotel?.additionalInfo?.numberOfRestaurants : 'N/A',
      },
            {
        title: 'Niños',
        image: '/assets/img/app/modal/child.svg',
        value: this.hotel?.additionalInfo?.acceptChildren && this.hotel?.additionalInfo?.acceptChildren > 0 ? this.hotel?.additionalInfo?.acceptChildren : 'N/A',
      },
      {
        title: 'Mascotas',
        image: '/assets/img/app/modal/perro.svg',
        value: this.hotel?.additionalInfo?.acceptPets && this.hotel?.additionalInfo?.acceptPets > 0 ? this.hotel?.additionalInfo?.acceptPets : 'N/A',
      },
      {
        title: 'Fumador',
        image: '/assets/img/app/modal/no-fumar.svg',
        value:  this.hotel?.additionalInfo?.suitableForSmoker ?? 'N/A',
      }
    );

    this.columnsInfoHotel = this.groupInColumns(this.infoHotel, 2)
  }

  groupInColumns(array: any[], itemsPerColumn: number): any[][] {
  const result = [];
  for (let i = 0; i < array.length; i += itemsPerColumn) {
    result.push(array.slice(i, i + itemsPerColumn));
  }
  return result;
}

  getAddress(location: string, beforeComma: boolean): string {
  if (!location) return '';

  const parts = location.split(',');

  if (beforeComma) {
    return parts[0]?.trim() || '';
  } else {
    return parts[1]?.trim() || '';
  }
}

getConfigurationRooms(roomConfiguration: any, type: string): number {
  return roomConfiguration.reduce((sum: number, room: any) => {
    return sum + (type === 'adults' ? Number(room.adults) : Number(room.children.length));
  }, 0);
}

onRefreshCalculatePrice(updatedRooms: any[]): void {
  // ✅ Transformar la estructura del hijo al formato que espera el padre
  const normalizedRooms = updatedRooms.map((childRoom: any, index: number) => {
    // La estructura del hijo tiene: childRoom.room (con addons) y childRoom.service
    // La estructura del padre espera: parentRoom.room.room

    return {
      room: {
        adults: this.selectedRooms[index].room.adults,
        childrens: this.selectedRooms[index].room.childrens,
        childsAge: this.selectedRooms[index].room.childsAge,
        productKey: this.selectedRooms[index].room.productKey,
        provider: this.selectedRooms[index].room.provider,
        stay: this.selectedRooms[index].room.stay,
        room: {
          ...childRoom.service,  // Los datos de la habitación van dentro de room.room
          addonsIncluded: childRoom.room?.addonsIncluded || [],
          netPriceBookingAddons: childRoom.room?.netPriceBookingAddons || 0
        }
      },
      // Calcular el total
      total: (childRoom.room?.netPriceBookingAddons || 0) + (childRoom.service?.optionNightsNetTotalProf || 0)
    };
  });

  // Reemplazar el array
  this.selectedRooms = normalizedRooms;
  // Calcular totales
  this.selectedRooms.forEach((roomItem: any) => {
    const addons = roomItem?.room?.room?.netPriceBookingAddons || 0;
    const basePrice = roomItem?.room?.room?.optionNightsNetTotalProf || 0;
    roomItem.total = basePrice + addons;

  });

  this.totalQty = this.selectedRooms.reduce((total, selectedRoom) => total + (selectedRoom.total || 0), 0);

}

filterTypeBoardName(index: number, boardSelect: any): void {

 if(this.selectedRooms.length === 0) {

    if(!this.mealsFilter.some(c => c.key === boardSelect)) return;

    if(this.selectedBoardKeys.includes(boardSelect)) {
      this.selectedBoardKeys.splice(boardSelect, 1);
      this.selectedOptionIndex[index] = false;
    } else {
      this.selectedBoardKeys.push(boardSelect)
      this.selectedOptionIndex[index] = true;
    }

  this.applyAllFilters();
     } else {
    this.deleteSelectedRoomsWithFilter(index, boardSelect, 'board');
   }
}

// selectedOptionIndexAcomodationFilter
filterTypeAcomodation(index: number, typeAcomodation: any): void {

  if(this.selectedRooms.length === 0) {

    if(!this.acomodationFilter.some(c => c.key === typeAcomodation)) return;

    if(this.selectedAcomodationFilter.includes(typeAcomodation)) {
      this.selectedAcomodationFilter.splice(typeAcomodation, 1);
      this.selectedOptionIndexAcomodationFilter[index] = false;
    } else {
      this.selectedAcomodationFilter.push(typeAcomodation);
      this.selectedOptionIndexAcomodationFilter[index] = true;
    }

  this.applyAllFilters();
   } else {
    this.deleteSelectedRoomsWithFilter(index, typeAcomodation, 'acomodation');
   }
}

filterTypeCancellation(index: number, typeCancellation: any): void {

 if(this.selectedRooms.length === 0) {

    if(!this.cancellationFilter.some(c => c.key === typeCancellation)) return;

      if(this.selectedTypeCancellation.includes(typeCancellation)) {
      this.selectedTypeCancellation.splice(typeCancellation, 1);
      this.selectedOptionIndexCancellationFilter[index] = false;
    } else {
      this.selectedTypeCancellation.push(typeCancellation);
      this.selectedOptionIndexCancellationFilter[index] = true;
    }

  this.applyAllFilters();
     } else {
    this.deleteSelectedRoomsWithFilter(index, typeCancellation, 'cancellation');
   }

}

deleteSelectedRoomsWithFilter(index: number, data: any, filterName: string): void {
  const dialogRef = this.dialog.open(MaterialModalConfirmComponent, {
    width: 'auto',
    minWidth: '650px',
    data: {
      message: 'Si acepta se borrarán todas las habitaciones seleccionadas',
      type: 'material',
      clientSetting: this.clientSetting
    },
    disableClose: true
  });

  dialogRef.afterClosed().subscribe((result: boolean) => {
    if (result) {
      // Limpiar todas las habitaciones seleccionadas en CADA componente hijo
      this.roomComponents.forEach((roomComponent: RoomComponent) => {
          if (roomComponent.clearSelection) {
            roomComponent.clearSelection();
          }
        });

      // Limpiar el array local
      this.selectedRooms = [];

      // Aplicar el filtro correspondiente
      switch (filterName) {
        case 'board':
          this.filterTypeBoardName(index, data);
          break;
        case 'acomodation':
          this.filterTypeAcomodation(index, data);
          break;
        case 'cancellation':
          this.filterTypeCancellation(index, data);
          break;
        default:
          break;
      }
    }
  });
}

applyAllFilters(): void {

  let filtered = [...this.originalRooms];

  if (this.selectedBoardKeys.length > 0) {
    // Obtener todos los matches de las keys seleccionadas (sin flatMap)
    let allMatches: string[] = [];
    this.mealsFilter.forEach(meal => {
      if (this.selectedBoardKeys.includes(meal.key)) {
        meal.matches.forEach(match => {
          allMatches.push(match.toLowerCase());
        });
      }
    });


    filtered = filtered.filter(room => {
      const boardName = room?.room?.boardName?.toLowerCase();
      const matches = allMatches.some(match => boardName === match || boardName?.includes(match));
      return matches;
    });
  }

  if(this.selectedAcomodationFilter.length > 0) {
    let allMatches: string[] = [];
    this.acomodationFilter.forEach(acomodation => {
      if(this.selectedAcomodationFilter.includes(acomodation.key)) {
        acomodation.matches.forEach(match => {
          allMatches.push(match.toLowerCase());
        })
      }
    });


    filtered = filtered.filter(room => {
      const acomodationName = room?.room?.roomBeds.filter((bed: any) => {
        const bedType = bed?.bedType?.toLowerCase();
        const matches = allMatches.some(match => bedType === match || acomodationName?.includes(match));
        return matches
      })
    })
  }

  if(this.selectedTypeCancellation.length > 0) {
    let allMatches: string[] = [];
    this.cancellationFilter.forEach(meal => {
      if (this.selectedTypeCancellation.includes(meal.key)) {
        meal.matches.forEach(match => {
          allMatches.push(match.toLowerCase());
        });
      }
    });


    filtered = filtered.filter(room => {
      const boardName = room?.room?.pricing?.rateClass?.toLowerCase();
      const matches = allMatches.some(match => boardName === match || boardName?.includes(match));
      return matches;
    });
  }

  this.hotel.additionalInfo.rooms = filtered;
  this.setRoomsGroup();
}


mealsFilters(): any[] {
  const iconMap: { [key: string]: string } = {
    breakfast: '../../../../assets/icons/search-result/hotel/filtro/01_DESAYUNO.svg',
    no_breakfast: '../../../../assets/icons/search-result/hotel/filtro/02_NO_DESAYUNO.svg',
    half_board: '../../../../assets/icons/search-result/hotel/filtro/03_MEDIA_PENSION.svg',
    full_board: '../../../../assets/icons/search-result/hotel/filtro/04_PENSION_COMPLETA.svg',
    all_inclusive: '../../../../assets/icons/search-result/hotel/filtro/05_ALL_INCLUSIVE.svg'
  };

  if (!this.mealsFilter || this.mealsFilter.length === 0) {
    return BoardTypes.map(board => ({
      key: board.key,
      name: board.label,
      icon: iconMap[board.key] || '',
      status: 'no_available',
      meals: null
    }));
  }

  // Crear un mapa para acceso rápido por key
  const filtersMap = new Map();
  this.mealsFilter.forEach(filter => {
    filtersMap.set(filter.key, filter);
  });

  return BoardTypes.map(board => {
    const matchingFilter = filtersMap.get(board.key);
    const isAvailable = !!matchingFilter;

    return {
      key: board.key,
      name: board.label,
      icon: iconMap[board.key] || '',
      status: isAvailable ? 'available' : 'no_available',
      meals: matchingFilter || null // Datos originales del filtro si está disponible
    };
  });
}

getAccomodationFilters(): any[] {
  if(!this.acomodationFilter || this.acomodationFilter.length === 0) {
    return AcomodationTypes.map(acomodation => ({
      key: acomodation.key,
      name: acomodation.label,
      status: 'no_available',
      acomodation: null
    }));
  }

  const filtersMap = new Map();
  this.acomodationFilter.forEach(filter => {
    filtersMap.set(filter.key, filter);
  });

  return AcomodationTypes.map(acomodation => {
    const matchingFilter = filtersMap.get(acomodation.key);
    const isAvailable = !! matchingFilter;

    return {
      key: acomodation.key,
      name: acomodation.label,
      status: isAvailable ? 'available' : 'no_available',
      acomodation: matchingFilter || null
    }
  })

}

cancellationFilters(): any[] {
  const iconMap: { [key: string]: string } = {
    R: '../../../../assets/icons/search-result/hotel/filtro/REEMBOLSO-01.svg',
    NR: '../../../../assets/icons/search-result/hotel/filtro/REEMBOLSO-02.svg',
  };

  // Definir orden de prioridad (R primero)
  const priorityOrder = ['R', 'NR'];

  // Ordenar CancellationTypes según prioridad
  const orderedTypes = [...CancellationTypes].sort((a, b) =>
    priorityOrder.indexOf(a.key) - priorityOrder.indexOf(b.key)
  );

  if (!this.cancellationFilter || this.cancellationFilter.length === 0) {
    return orderedTypes.map(board => ({
      key: board.key,
      name: board.label,
      icon: iconMap[board.key] || '',
      status: 'no_available',
      meals: null
    }));
  }

  // Crear un mapa para acceso rápido por key
  const filtersMap = new Map();
  this.cancellationFilter.forEach(filter => {
    filtersMap.set(filter.key, filter);
  });

  return orderedTypes.map(board => {
    const matchingFilter = filtersMap.get(board.key);
    const isAvailable = !!matchingFilter;

    return {
      key: board.key,
      name: board.label,
      icon: iconMap[board.key] || '',
      status: isAvailable ? 'available' : 'no_available',
      meals: matchingFilter || null
    };
  });
}

  getStarsHotels(rate: string): number {
    return starsHotels(rate);
  }

  goPhothosTab(): void {
    this.tab = 'photos';
  }


}


// selectedRooms
